import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: 720,
  maxWidth: '95vw',
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(1),
  gap: (p) => p.spacing(1),
  width: 710,
  maxWidth: '95vw',
  boxSizing: 'border-box',
};
